// extracted by mini-css-extract-plugin
export var anchor = "index-module--anchor--qveVu";
export var anchorWrapper = "index-module--anchor-wrapper--90tD+";
export var dot = "index-module--dot--shoSJ";